// Tlačítko „Do Hlídače" — sdílené na profilu hráče i ve finderech.
import React from "react";
import { Siren, Check } from "@phosphor-icons/react";
import { toast } from "sonner";
import { useSharedPool, POOL_MAX } from "../lib/timing-pool-store";

export function DnaPoolButton({ player, compact = false }) {
    const { addPlayer, removePlayer, hasPlayer, pool } = useSharedPool();
    if (!player?.fpl_id) return null;
    const inPool = hasPlayer(player.fpl_id);

    const toggle = () => {
        if (inPool) {
            removePlayer(player.fpl_id);
            toast.success(`${player.name} odebrán z Hlídače`);
            return;
        }
        if (pool.length >= POOL_MAX) { toast.error(`Hlídač je plný (max ${POOL_MAX} hráčů)`); return; }
        addPlayer({
            fpl_id: player.fpl_id,
            display_name: player.name,
            historical_slug: player.player_key || null,
            position: player.position,
            team: player.team,
            current_price: player.price ?? null,
            ownership_pct: player.ownership_pct ?? 0,
            seasons_available: 0,
            match_confidence: 100,
        });
        toast.success(`${player.name} → Hlídač (${pool.length + 1})`);
    };

    if (compact) {
        return (
            <button type="button" onClick={toggle} data-testid={`dna-pool-btn-${player.fpl_id}`}
                    title={inPool ? "Odebrat z Hlídače" : "Přidat do Hlídače (sledování + Team Season DNA)"}
                    className={`p-1 border transition-colors ${inPool
                        ? "border-[#FF8800]/60 text-[#FF8800] bg-[#FF8800]/10 hover:text-red-300 hover:border-red-300/50"
                        : "border-white/15 text-white/40 hover:text-[#FF8800] hover:border-[#FF8800]/50"}`}>
                <Siren size={12} weight="bold" />
            </button>
        );
    }
    return (
        <button type="button" onClick={toggle} data-testid={`dna-pool-btn-${player.fpl_id}`}
                className={`font-mono text-[10px] uppercase tracking-widest px-4 py-2 border flex items-center gap-1.5 transition-colors ${inPool
                    ? "border-[#FF8800]/60 text-[#FF8800] bg-[#FF8800]/10 hover:text-red-300 hover:border-red-300/50"
                    : "border-[#FF8800]/50 text-[#FF8800] hover:bg-[#FF8800] hover:text-black"}`}>
            {inPool ? <><Check size={12} weight="bold" /> v Hlídači</> : <><Siren size={12} weight="bold" /> Do Hlídače</>}
        </button>
    );
}
